// @flow
import React, { Fragment } from 'react';
import { OptionsInner, Bullets, Expand, Price, ButtonContainer, Option, ProfDisclaimer } from '../partials';
import type { OptionsType } from './data';
import { options, plusOptions } from './data';

type Props = {
  plus?: boolean,
  option: OptionsType,
  url: string
};

export const OptionCard = ({ plus = false, option, url }: Props) => {
  if (plus) {
    const data = plusOptions[option];

    const Logo = data.logo ? data.logo : <Fragment />;

    return (
      <OptionsInner plus background={data.background} color={data.color} color2={data.color2}>
        {data.logo && <Logo {...data.logoProps} />}

        {data.title.includes('<') ? <h4 dangerouslySetInnerHTML={{ __html: data.title }} /> : <h4>{data.title}</h4>}

        <Bullets fontSize={data.bulletsSize || 1}>
          {data.bullets.map((bullet, index) => (
            <span key={index} className="bullet">
              {bullet}
            </span>
          ))}
        </Bullets>

        <Expand />

        <div className="price">
          <Price priceFontSize={data.priceFontSize}>
            {data.price}
            {data.period ? <span> / {data.period}</span> : ''}
          </Price>
        </div>

        <ButtonContainer background={data.buttonBackgroundColor} color={data.buttonColor}>
          <a href={`${url}${option !== 'free' ? '?plan=monthly' : ''}`} rel="nofollow">
            {data.button}
          </a>
        </ButtonContainer>

        {option !== 'free' && (
          <>
            <div className="price" style={{ marginTop: '40px' }}>
              <Price
                priceFontSize={data.priceFontSize ? data.priceFontSize - 3 : undefined}
                strikethrough
                priceFontWeight={200}
              >
                {data.priceYearlyNope}
                {data.priceYearlyPeriod ? <span> / {data.priceYearlyPeriod}</span> : ''}
              </Price>

              <Price priceFontSize={data.priceFontSize}>
                {data.priceYearly}
                {data.priceYearlyPeriod ? <span> / {data.priceYearlyPeriod}</span> : ''}
              </Price>
            </div>

            <ButtonContainer background={data.buttonBackgroundColor2} color={data.buttonColor}>
              <a href={`${url}?plan=yearly`} rel="nofollow">
                {data.button}
              </a>
            </ButtonContainer>

            <ProfDisclaimer>
              <span>*Profesionales gratis durante 3 meses</span>
            </ProfDisclaimer>

            <ProfDisclaimer>
              <p>
                Si necesitas contratar más de una cuenta, contacta con nosotros en{' '}
                <a href="mailto:sales@finect.com">sales@finect.com</a>.
              </p>
            </ProfDisclaimer>
          </>
        )}

        {/* <ButtonContainer background={data.buttonBackgroundColor} color={data.buttonColor}>
          <a href={url} rel="nofollow">
            {data.button}
          </a>
        </ButtonContainer> */}
      </OptionsInner>
    );
  }

  const data = options[option];

  return (
    <OptionsInner>
      <h4>{data.title}</h4>

      <span>{data.highlight}</span>

      <div>
        {data.price}
        {data.period ? <span> / {data.period}</span> : ''}
      </div>

      <Option primary as="a" href={url} rel="nofollow">
        {data.button}
      </Option>
    </OptionsInner>
  );
};
